/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts, text } = theme;

export const smallPill = css`
  padding: 0 ${pxToRem(4)} 0 ${pxToRem(5)};
  height: ${pxToRem(16)};
  width: ${pxToRem(35)};
  border-radius: ${pxToRem(spacing.xs)};
  background-color: var(--neutral-black-70);
  color: var(--neutral-white-base);
  text-align: center;
  line-height: ${pxToRem(16)};
  font-size: ${pxToRem(text.BODY.XS.fontSize)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
